/* Sign-in card: email or mobile, one-time code, short profile.
   Talks to our sign-in service (data-api). With no service set it runs in demo mode inside the browser. */
(function(){
  var box=document.querySelector('[data-auth]');if(!box)return;
  var API=(box.getAttribute('data-api')||'').replace(/\/$/,''),DEMO=!API,KEY='mb_auth';
  var state={mode:box.getAttribute('data-mode')||'mobile',to:'',via:'whatsapp',timer:null};
  function $(s,r){return (r||box).querySelector(s)}
  function $$(s,r){return Array.prototype.slice.call((r||box).querySelectorAll(s))}
  function load(){try{return JSON.parse(localStorage.getItem(KEY)||'null')}catch(e){return null}}
  function save(v){try{v?localStorage.setItem(KEY,JSON.stringify(v)):localStorage.removeItem(KEY)}catch(e){}try{document.dispatchEvent(new CustomEvent('mb:auth'))}catch(e){}}
  var me=load();

  // ---------- talking to the sign-in service ----------
  function call(path,body,token){
    if(DEMO)return demo(path,body);
    return fetch(API+path,{method:body?'POST':'GET',headers:Object.assign({'Content-Type':'application/json'},token?{'Authorization':'Bearer '+token}:{}),body:body?JSON.stringify(body):undefined})
      .then(function(r){return r.json().catch(function(){return {}}).then(function(j){if(!r.ok)throw new Error(j.error||'Something went wrong. Please try again.');return j})});
  }
  function demo(path,body){
    return new Promise(function(ok,no){setTimeout(function(){
      if(path==='/otp/send')return ok({ok:true});
      if(path==='/otp/verify'){if(body.code!=='123456')return no(new Error('That code is not right. In the demo it is 123456.'));
        var old=load();return ok({token:'demo',customer:(old&&old.customer&&old.customer.to===body.to)?old.customer:{to:body.to,name:'',who:'',inst:''}})}
      if(path==='/profile'){var c=Object.assign({},(load()||{}).customer,body);return ok({customer:c})}
      ok({});
    },450)});
  }

  // ---------- steps ----------
  function step(n){
    $$('[data-auth-step]').forEach(function(s){s.hidden=s.getAttribute('data-auth-step')!==n});
    $('[data-auth-back]').hidden=n!=='code';
    $$('[data-auth-err]').forEach(function(e){e.hidden=true});
    var f=$('[data-auth-step="'+n+'"] input:not([type=radio]):not([hidden])');
    setTimeout(function(){if(f&&f.offsetParent)f.focus()},30);
  }
  function err(scope,msg){var e=$('[data-auth-step="'+scope+'"] [data-auth-err]');e.textContent=msg;e.hidden=false}
  function busy(form,on,label){var b=$('button[type=submit]',form);b.disabled=on;if(label)b.textContent=label}
  function open(){
    $('[data-auth-demo]').hidden=!DEMO;
    if(me&&me.customer)fillProfile(true);else step('start');
    box.hidden=false;document.documentElement.style.overflow='hidden';
  }
  function toast(t){var el=document.querySelector('.mb-toast');if(!el)return;el.textContent=t;el.classList.add('is-on');setTimeout(function(){el.classList.remove('is-on')},2500)}
  function close(){box.hidden=true;document.documentElement.style.overflow='';clearInterval(state.timer)}
  function paintIcon(){document.querySelectorAll('[data-auth-open]').forEach(function(a){a.classList.toggle('is-in',!!(me&&me.customer));a.setAttribute('aria-label',me&&me.customer?'Your account':'Sign in')})}

  // 1. email or mobile
  var start=$('[data-auth-step="start"]');
  $$('[data-auth-mode]').forEach(function(b){b.addEventListener('click',function(){
    state.mode=b.getAttribute('data-auth-mode');
    $$('[data-auth-mode]').forEach(function(x){var on=x===b;x.classList.toggle('is-on',on);x.setAttribute('aria-selected',on?'true':'false')});
    $$('[data-auth-for]',start).forEach(function(el){el.hidden=el.getAttribute('data-auth-for')!==state.mode});
    $('[data-auth-err]',start).hidden=true;
    var f=$('[data-auth-for="'+state.mode+'"] input',start);if(f)f.focus();
  })});
  // accepts pasted numbers like +91 98848 12345 or 098848-12345
  function ten(v){v=v.replace(/\D/g,'');return v.length>10?v.slice(-10):v}
  start.elements.phone.addEventListener('input',function(){this.value=ten(this.value)});
  start.addEventListener('submit',function(e){
    e.preventDefault();
    var to,via;
    if(state.mode==='mobile'){var p=ten(start.elements.phone.value);if(!/^[6-9]\d{9}$/.test(p))return err('start','Enter a 10-digit mobile number.');to='+91'+p;via=start.querySelector('[name=via]:checked').value}
    else{to=start.elements.email.value.trim().toLowerCase();if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(to))return err('start','Enter a valid email address.');via='email'}
    state.to=to;state.via=via;send(start);
  });
  function send(form){
    busy(form,true,'Sending…');
    call('/otp/send',{to:state.to,channel:state.via}).then(function(){
      $('[data-auth-to]').textContent=state.mode==='mobile'?state.to.replace(/^\+91/,'+91 '):state.to;
      $('[data-auth-via]').textContent=state.via==='whatsapp'?'on WhatsApp':state.via==='sms'?'by SMS':'by email';
      clearOtp();step('code');wait();
    }).catch(function(x){err(form.getAttribute('data-auth-step'),x.message)}).finally(function(){busy(form,false,form===start?'Send code':'Verify')});
  }

  // 2. the code
  var code=$('[data-auth-step="code"]'),digits=$$('[data-auth-otp] input');
  function clearOtp(){digits.forEach(function(d){d.value=''})}
  function otp(){return digits.map(function(d){return d.value}).join('')}
  digits.forEach(function(d,i){
    d.addEventListener('input',function(){
      var v=d.value.replace(/\D/g,'');
      if(v.length>1){v.split('').slice(0,6-i).forEach(function(c,k){digits[i+k].value=c});var n=Math.min(i+v.length,5);digits[n].focus()}
      else{d.value=v;if(v&&i<5)digits[i+1].focus()}
      if(otp().length===6)code.requestSubmit();
    });
    d.addEventListener('keydown',function(e){if(e.key==='Backspace'&&!d.value&&i>0){digits[i-1].focus();digits[i-1].value=''}});
  });
  function wait(){
    var left=30,w=$('[data-auth-wait]'),r=$('[data-auth-resend]');r.hidden=true;w.hidden=false;
    clearInterval(state.timer);w.textContent='Resend in 0:30';
    state.timer=setInterval(function(){left--;w.textContent='Resend in 0:'+(left<10?'0':'')+left;if(left<=0){clearInterval(state.timer);w.hidden=true;r.hidden=false}},1000);
  }
  $('[data-auth-resend]').addEventListener('click',function(){send(code)});
  $('[data-auth-change]').addEventListener('click',function(){step('start')});
  $('[data-auth-back]').addEventListener('click',function(){step('start')});
  code.addEventListener('submit',function(e){
    e.preventDefault();var c=otp();if(c.length!==6)return err('code','Enter all 6 digits.');
    busy(code,true,'Checking…');
    call('/otp/verify',{to:state.to,code:c}).then(function(r){
      me={token:r.token,customer:Object.assign({to:state.to},r.customer||{})};save(me);paintIcon();
      clearInterval(state.timer);
      if(me.customer.name){close();toast('Signed in. Welcome back, '+me.customer.name.split(' ')[0]+'.')}else fillProfile(false);
      // checkout can pick up who this is
      fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'Signed in as':state.to}})}).catch(function(){});
    }).catch(function(x){err('code',x.message);clearOtp();digits[0].focus()}).finally(function(){busy(code,false,'Verify')});
  });

  // 3. profile: asked once after the first code, and shown again when a signed-in person taps the icon
  var prof=$('[data-auth-step="profile"]'),FIELDS=['name','inst','city','year'];
  function who(){return prof.querySelector('[name=who]:checked').value}
  function label(){var w=who();$('[data-auth-instlabel]').textContent=w==='Student'?'College':w==='Practitioner'?'Hospital or clinic':'Institution';$('[data-auth-year]').hidden=w!=='Student'}
  function fillProfile(edit){
    var c=(me&&me.customer)||{};
    FIELDS.forEach(function(f){prof.elements[f].value=c[f]||''});
    $$('[name=who]',prof).forEach(function(r){r.checked=r.value===(c.who||'Student')});label();
    $('[data-auth-ptitle]').textContent=edit?'Your details':'A little about you';
    $('[data-auth-skip]').hidden=!!edit;$('[data-auth-out]').hidden=!edit;$('[data-auth-orders]').hidden=!edit;
    step('profile');
  }
  prof.addEventListener('change',function(e){if(e.target.name==='who')label()});
  prof.addEventListener('submit',function(e){
    e.preventDefault();
    var p={who:who()};FIELDS.forEach(function(f){p[f]=prof.elements[f].value.trim()});
    if(p.who!=='Student')p.year='';
    if(!p.name){prof.elements.name.focus();return err('profile','Please enter your name.')}
    busy(prof,true,'Saving…');
    call('/profile',p,me&&me.token).then(function(r){
      me.customer=Object.assign(me.customer,r.customer||p);save(me);
      fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'Name':p.name,'Buyer':p.who,'Institution':p.inst,'City':p.city,'Year':p.year}})}).catch(function(){});
      close();toast('You’re signed in, '+p.name.split(' ')[0]+'.');
    }).catch(function(x){err('profile',x.message)}).finally(function(){busy(prof,false,'Save')});
  });
  $('[data-auth-skip]').addEventListener('click',function(){close();toast('You’re signed in.')});
  $('[data-auth-out]').addEventListener('click',function(){
    if(!DEMO&&me&&me.token)call('/logout',{},me.token).catch(function(){});
    me=null;save(null);paintIcon();close();toast('Signed out.');
  });

  // signed in: the header icon opens a small menu (orders first); elsewhere the card opens as before
  var menu=document.querySelector('[data-umenu]');
  function menuOpen(btn){
    var c=me.customer||{},r=btn.getBoundingClientRect();
    menu.querySelector('[data-umenu-hi]').innerHTML=c.name?'Signed in as<b>'+c.name.replace(/[&<>"']/g,'')+'</b>':'Signed in as<b>'+(c.to||'').replace(/[&<>"']/g,'')+'</b>';
    menu.hidden=false;
    var w=menu.offsetWidth;menu.style.top=(r.bottom+8)+'px';menu.style.left=Math.max(8,Math.min(window.innerWidth-w-8,r.right-w))+'px';
    btn.setAttribute('aria-expanded','true');menu._btn=btn;
    var f=menu.querySelector('a,button');if(f)f.focus();
  }
  function menuClose(){if(!menu||menu.hidden)return;menu.hidden=true;if(menu._btn)menu._btn.setAttribute('aria-expanded','false')}
  if(menu){
    menu.querySelector('[data-umenu-out]').addEventListener('click',function(){menuClose();$('[data-auth-out]').click()});
    window.addEventListener('resize',menuClose);window.addEventListener('scroll',menuClose,{passive:true});
  }
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-auth-open]');
    if(t){e.preventDefault();
      if(menu&&me&&me.customer&&t.closest('.mb-head, header')){if(!menu.hidden&&menu._btn===t)menuClose();else menuOpen(t);return}
      menuClose();open();return}
    if(menu&&!menu.hidden&&!e.target.closest('[data-umenu]'))menuClose();
    if(e.target===box||e.target.closest('[data-auth-close]')){close();return}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){if(menu&&!menu.hidden){menuClose();if(menu._btn)menu._btn.focus()}else if(!box.hidden)close()}});
  // the account page edits the same session: pick up its changes
  document.addEventListener('mb:auth',function(){me=load();paintIcon()});

  // checkout: fill in the email and default address of a signed-in buyer.
  // Uses a cart link (/cart/variant:qty,...?checkout[...]); falls back to the normal checkout if anything is off.
  var ST={AN:'Andaman and Nicobar Islands',AP:'Andhra Pradesh',AR:'Arunachal Pradesh',AS:'Assam',BR:'Bihar',CH:'Chandigarh',CG:'Chhattisgarh',DN:'Dadra and Nagar Haveli and Daman and Diu',DL:'Delhi',GA:'Goa',GJ:'Gujarat',HR:'Haryana',HP:'Himachal Pradesh',JK:'Jammu and Kashmir',JH:'Jharkhand',KA:'Karnataka',KL:'Kerala',LA:'Ladakh',LD:'Lakshadweep',MP:'Madhya Pradesh',MH:'Maharashtra',MN:'Manipur',ML:'Meghalaya',MZ:'Mizoram',NL:'Nagaland',OR:'Odisha',PY:'Puducherry',PB:'Punjab',RJ:'Rajasthan',SK:'Sikkim',TN:'Tamil Nadu',TS:'Telangana',TR:'Tripura',UP:'Uttar Pradesh',UK:'Uttarakhand',WB:'West Bengal'};
  function checkoutUrl(cart,c){
    if(!cart||!cart.items||!cart.items.length)return null;
    for(var i=0;i<cart.items.length;i++){var it=cart.items[i];if(it.selling_plan_allocation||(it.properties&&Object.keys(it.properties).some(function(k){return it.properties[k]!==''&&it.properties[k]!=null})))return null}
    var a=(c.addresses||[]).filter(function(x){return x.isDefault})[0]||(c.addresses||[])[0];
    var email=c.email||(/@/.test(c.to||'')?c.to:'');
    if(!a&&!email)return null;
    var q=[],add=function(k,v){if(v)q.push(encodeURIComponent(k)+'='+encodeURIComponent(v))};
    add('checkout[email]',email);
    if(a){var n=(a.name||c.name||'').trim().split(/\s+/),last=n.length>1?n.pop():'';
      add('checkout[shipping_address][first_name]',n.join(' '));add('checkout[shipping_address][last_name]',last);
      add('checkout[shipping_address][company]',a.company);add('checkout[shipping_address][address1]',a.line1);add('checkout[shipping_address][address2]',a.line2);
      add('checkout[shipping_address][city]',a.city);add('checkout[shipping_address][province]',ST[a.state]||a.state);
      add('checkout[shipping_address][country]','India');add('checkout[shipping_address][zip]',a.pin)}
    var at=cart.attributes||{};Object.keys(at).forEach(function(k){add('attributes['+k+']',at[k])});
    add('note',cart.note);
    var codes=(cart.discount_codes||[]).filter(function(d){return d.applicable}).map(function(d){return d.code});
    add('discount',codes.join(','));
    return '/cart/'+cart.items.map(function(it){return it.variant_id+':'+it.quantity}).join(',')+(q.length?'?'+q.join('&'):'');
  }
  document.addEventListener('click',function(e){
    var t=e.target.closest('button[name=checkout],input[name=checkout],a[href="/checkout"],a[href^="/checkout?"],[data-checkout]');
    if(!t||!me||!me.customer||e.defaultPrevented)return;
    var c=me.customer;if(!(c.addresses&&c.addresses.length)&&!c.email&&!/@/.test(c.to||''))return;
    e.preventDefault();e.stopPropagation();
    var form=t.form||t.closest('form');
    var go=function(){location.href='/checkout'};
    // a cart form may have unsaved quantity changes: save them first
    var first=form&&/\/cart/.test(form.getAttribute('action')||'')?fetch('/cart/update.js',{method:'POST',body:new FormData(form)}).catch(function(){}):Promise.resolve();
    first.then(function(){return fetch('/cart.js',{headers:{Accept:'application/json'}})}).then(function(r){return r.json()})
      .then(function(cart){var u=checkoutUrl(cart,c);location.href=u||'/checkout'}).catch(go);
  },true);

  paintIcon();
  window.mbAuth={open:open,me:function(){return me&&me.customer}};
})();
